import { SetSearchTerms, ToggleOpenState } from './types'

export const setSearchTerms = (searchTerms: string): SetSearchTerms => ({
  type: '@OXD/SET_SEARCH_TERMS',
  payload: searchTerms,
})

export const toggleOpenState = (isOpen: boolean): ToggleOpenState => ({
  type: '@OXD/TOGGLE_OPEN_STATE',
  payload: isOpen,
})
